export default function(data) {
  return {
    licenseFinishDate: data.licenseFinishDate,
  }
}
